import {cartCount, ifAuthenticated, ifNotAuthenticated} from './frontend/middleware'

export default {
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import(/*webpackChunkName:"home"*/'./frontend/pages/Home')
        },
        {
            path: '/register',
            name: 'Register',
            component: () => import(/*webpackChunkName:"register"*/'./frontend/pages/Register'),
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/search',
            name: 'Search',
            component: () => import(/*webpackChunkName:"search"*/'./frontend/pages/Search'),
        },
        {
            path: '/seller/:id',
            name: 'Seller',
            component: () => import(/*webpackChunkName:"seller"*/'./frontend/pages/Seller')
        },
        {
            path: '/cart',
            name: 'Cart',
            component: () => import(/*webpackChunkName:"cart"*/'./frontend/pages/Cart'),
            beforeEnter: cartCount
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: () => import(/*webpackChunkName:"checkout"*/'./frontend/pages/Checkout'),
            beforeEnter: cartCount
        },
        {
            path: '/thank-you/:id',
            name: 'ThankYou',
            component: () => import(/*webpackChunkName:"thank-you"*/'./frontend/pages/ThankYou')
        },
        {
            path: '/payment-failed',
            name: 'PaymentFailed',
            component: () => import(/*webpackChunkName:"thank-you"*/'./frontend/pages/PaymentFailed')
        },
        {
            path: '/reset',
            name: 'ResetPassword',
            component: () => import(/*webpackChunkName:"reset"*/'./frontend/pages/ResetPassword')
        },
        {
            path: '/profile',
            name: 'Profile',
            component: () => import(/*webpackChunkName:"profile"*/'./frontend/pages/Profile'),
            children: [
                {
                    path: '/order/:id',
                    name: 'order',
                    component: () => import(/*webpackChunkName:"product-review"*/'./frontend/Screens/Profile/ProductReview')
                },
                {
                    path: '/address_edit/:id',
                    name: 'order',
                    component: () => import(/*webpackChunkName:"address-edit"*/'./frontend/Screens/Profile/AddressEdit')
                },
                {
                    path: '',
                    name: 'View Profile',
                    component: () => import(/*webpackChunkName:"view-profile"*/'./frontend/Screens/Profile/ViewProfile')
                },
                {
                    path: 'wishlist',
                    name: 'Wishlist',
                    component: () => import(/*webpackChunkName:"wishlist"*/'./frontend/Screens/Profile/Wishlist')
                },
                {
                    path: 'order_history',
                    name: 'Order History',
                    component: () => import(/*webpackChunkName:"order-history"*/'./frontend/Screens/Profile/OrderHistory')
                },
                {
                    path: 'edit_profile',
                    name: 'Edit Profile',
                    component: () => import(/*webpackChunkName:"edit-profile"*/'./frontend/Screens/Profile/EditProfile')
                },
                {
                    path: 'address',
                    name: 'address',
                    component: () => import(/*webpackChunkName:"address"*/'./frontend/Screens/Profile/Address')
                },
                {
                    path: 'return',
                    name: 'return',
                    component: () => import(/*webpackChunkName:"return"*/'./frontend/Screens/Profile/Return')
                },
            ],
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/affiliate',
            name: 'affiliate',
            component: () => import(/*webpackChunkName:"affiliate"*/'./frontend/other-page/affiliate'),
        },
        {
            path: '/affiliate_form',
            name: 'affiliate_form',
            component: () => import(/*webpackChunkName:"affiliateForm"*/'./frontend/other-page/affiliate-form'),
        },
        {
            path: '/check_warranty',
            name: 'check_warranty',
            component: () => import(/*webpackChunkName:"checkWarranty"*/'./frontend/other-page/check-warranty'),
        },
        {
            path: '/check_warranty',
            name: 'check_warranty',
            component: () => import(/*webpackChunkName:"checkWarranty"*/'./frontend/other-page/check-warranty'),
        },
        {
            path: '/corporate',
            name: 'corporate',
            component: () => import(/*webpackChunkName:"corporate"*/'./frontend/other-page/corporate'),
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import(/*webpackChunkName:"faq"*/'./frontend/other-page/faq'),
        },
        {
            path: '/franchise_form',
            name: 'franchise_form',
            component: () => import(/*webpackChunkName:"FranchiseForm"*/'./frontend/other-page/franchise-form'),
        },
        {
            path: '/islamic_insurance',
            name: 'islamic_insurance',
            component: () => import(/*webpackChunkName:"islamicInsurance"*/'./frontend/other-page/islamic-insurance'),
        },

        {
            path: '/mobile_app',
            name: 'mobile_app',
            component: () => import(/*webpackChunkName:"mobileApp"*/'./frontend/other-page/mobile-app'),
        },
        {
            path: '/other_seller',
            name: 'other_seller',
            component: () => import(/*webpackChunkName:"otherSeller"*/'./frontend/other-page/other-seller'),
        },
        {
            path: '/payment_information',
            name: 'payment_information',
            component: () => import(/*webpackChunkName:"paymentInformation"*/'./frontend/other-page/payment-information'),
        },
        {
            path: '/qisst-pay-information',
            name: 'qisst-pay-information',
            component: () => import(/*webpackChunkName:"qisstPayInformation"*/'./frontend/other-page/qisst-pay-information'),
        },
        {
            path: '/price_beating_policy',
            name: 'price_beating_policy',
            component: () => import(/*webpackChunkName:"priceBeatingPolicy"*/'./frontend/other-page/price-beating-policy'),
        },
        {
            path: '/privacy-policy',
            name: 'privacy',
            component: () => import(/*webpackChunkName:"privacy"*/'./frontend/other-page/privacy'),
        },
        {
            path: '/shipping_information',
            name: 'shipping_information',
            component: () => import(/*webpackChunkName:"shippingInformation"*/'./frontend/other-page/shipping-information'),
        },
        {
            path: '/telemart_franchise',
            name: 'telemart_franchise',
            component: () => import(/*webpackChunkName:"telemartFranchise"*/'./frontend/other-page/telemart-franchise'),
        },
        {
            path: '/telemart_franchise_program',
            name: 'telemart_franchise_program',
            component: () => import(/*webpackChunkName:"telemartFranchiseProgram"*/'./frontend/other-page/telemart-franchise-program'),
        },
        {
            path: '/terms_condition',
            name: 'terms_condition',
            component: () => import(/*webpackChunkName:"termsCondition"*/'./frontend/other-page/termas-condition'),
        },
        {
            path: '/testimonial',
            name: 'testimonial',
            component: () => import(/*webpackChunkName:"testimonial"*/'./frontend/other-page/testimonial'),
        },
        {
            path: '/vendor_registration',
            name: 'vendor_registration',
            component: () => import(/*webpackChunkName:"vendorRegistration"*/'./frontend/other-page/vendor-registration'),
        },
        {
            path: '/7-day-checking-warranty-at-telemart',
            name: 'warranty_telemart',
            component: () => import(/*webpackChunkName:"warrantyTelemart"*/'./frontend/other-page/warranty-telemart'),
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/*webpackChunkName:"about"*/'./frontend/other-page/about'),
        },
        {
            path: '/brands',
            name: 'brands',
            component: () => import(/*webpackChunkName: 'brands'*/'./frontend/pages/BrandList'),
        },
        {
            path: '*',
            name: 'shop',
            component: () => import(/*webpackChunkName:"shop"*/'./frontend/pages/Shop'),
        },
        {
            path: '/smartphone-financing',
            name: 'emi_application',
            component: () => import(/*webpackChunkName:"corporate"*/'./frontend/Screens/EMI/index'),
        },
        {
            path: '/QRdeals',
            name: 'visaForm',
            component: () => import(/*webpackChunkName:"visaform"*/'./frontend/Screens/Visa/index'),
        },
        {
            path: '/zong',
            name: 'zongDeals',
            component: () => import(/*webpackChunkName:"zongDeals"*/'./frontend/Screens/ZongDeals/Index')
        },
        {
            path: '/jazz',
            name: 'jazzDeals',
            component: () => import(/*webpackChunkName:"jazzDeals"*/'./frontend/Screens/JazzDeals/Index')
        }
    ]
};
